import { IconLock } from '../../../../../components/Icons/IconLock'
import { IconUnlock } from '../../../../../components/Icons/IconUnlock'
import styles from './styles.css'

export const LockUnlockIcon = ({ lockedForEdit }) => {
  return <div className={styles.lockUnlock}>{lockedForEdit ? <IconLock /> : <IconUnlock />}</div>
}
